import * as React from 'react';

import SelectButton from '@/components/elements/Button/SelectButton';
import { BetType } from '@/lib/apollo/types/gen/graphql';
import { WheelAxis, WheelAxisList } from '@/modelTypes';

import { WheelWrapper } from '../style';

interface BetTypeRadioProps {
  betType: BetType;
  wheelAxis: WheelAxis;
  isModifyingDisabled: (
    key: 'betMethod' | 'betType' | 'wheelAxis',
    arg: string,
  ) => boolean;
  setWheelAxisList: React.Dispatch<React.SetStateAction<WheelAxisList>>;
}

type AxisButton = {
  displayName: string;
  type: WheelAxis;
};

const BetTypeRadio: React.FC<BetTypeRadioProps> = ({
  betType,
  wheelAxis,
  isModifyingDisabled,
  setWheelAxisList,
}) => {
  const trifectaAxis: AxisButton[] = [
    {
      displayName: '1着軸',
      type: WheelAxis.First,
    },
    {
      displayName: '2着軸',
      type: WheelAxis.Second,
    },
    {
      displayName: '3着軸',
      type: WheelAxis.Third,
    },
    {
      displayName: '1・2着軸',
      type: WheelAxis.FirstSecond,
    },
    {
      displayName: '1・3着軸',
      type: WheelAxis.FirstThird,
    },
    {
      displayName: '2・3着軸',
      type: WheelAxis.SecondThird,
    },
  ];

  const trioAxis: AxisButton[] = [
    {
      displayName: '1軸',
      type: WheelAxis.One,
    },
    {
      displayName: '2軸',
      type: WheelAxis.Two,
    },
  ];

  const perfectaAxis: AxisButton[] = [
    {
      displayName: '1着軸',
      type: WheelAxis.First,
    },
    {
      displayName: '2着軸',
      type: WheelAxis.Second,
    },
  ];

  const displayButtons = (): AxisButton[] => {
    if (betType === BetType.Trifecta) return trifectaAxis;
    if (betType === BetType.Trio) return trioAxis;
    if (betType === BetType.Perfecta || betType === BetType.BracketPerfecta)
      return perfectaAxis;
    return [];
  };

  const handleClick = (type: WheelAxis) => {
    setWheelAxisList(prev => {
      const newList = { ...prev };
      newList[betType] = type;
      return newList;
    });
  };

  return (
    <WheelWrapper>
      {displayButtons().map((btn, i) => (
        <SelectButton
          key={`displayBtn-${i}`}
          bgColor="secondary"
          size="s"
          width="100%"
          clicked={wheelAxis === btn.type}
          disabled={isModifyingDisabled('wheelAxis', btn.type)}
          onClick={() => handleClick(btn.type)}
        >
          {btn.displayName}
        </SelectButton>
      ))}
    </WheelWrapper>
  );
};

export default BetTypeRadio;
